import {
  CommonModule,
} from "@angular/common";
import {
  Component,
  forwardRef,
  Injectable,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from "@angular/forms";
import { Subscription } from "rxjs";
import {
  NgbTimeAdapter,
  NgbTimepickerModule,
  NgbTimeStruct,
} from "@ng-bootstrap/ng-bootstrap";
import { GenerateRandom } from "src/utils/random";
import { LabelMode } from "src/utils/label-mode.enum";
import { TranslateModule } from "@ngx-translate/core";

const pad = (i: number): string => (i < 10 ? `0${i}` : `${i}`);

@Injectable()
export class NgbTimeStringAdapter extends NgbTimeAdapter<string> {
  fromModel(value: string | null): NgbTimeStruct | null {
    if (value === null || value === "") {
      return null;
    }
    const split = value.split(":");
    return {
      hour: parseInt(split[0], 10),
      minute: parseInt(split[1], 10),
      second: parseInt(split[2], 10),
    };
  }

  toModel(time: NgbTimeStruct | null): string | null {
    return time != null
      ? `${pad(time.hour)}:${pad(time.minute)}:${pad(time.second)}`
      : null;
  }
}

@Component({
  selector: "app-timepicker",
  templateUrl: "./timepicker.component.html",
  styleUrls: ["./timepicker.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TimepickerComponent),
      multi: true,
    },
    { provide: NgbTimeAdapter, useClass: NgbTimeStringAdapter },
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbTimepickerModule,
    TranslateModule,
  ],
})
export class TimepickerComponent
  implements OnInit, OnDestroy, ControlValueAccessor
{
  @Input() name = GenerateRandom(6);
  @Input() label: string;
  @Input() spinners = false;
  @Input() classes: string;
  @Input() modeClass: string;
  @Input() required = false;

  subscription: Subscription;
  errorMessage: string;
  LabelMode = LabelMode;
  mode: LabelMode = LabelMode.DEFAULT;

  form = new FormControl();

  isError = false;

  constructor() {}

  @Input()
  set isDisabled(value: boolean) {
    if (value) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }

  @Input()
  set error(value: unknown) {
    this.isError = false;
    if (value !== null && value !== undefined && value !== false) {
      this.isError = true;
      this.errorMessage = "VALIDATOR.REQUIRED";
    }
  }

  @Input() set labelMode(value: LabelMode) {
    this.mode = value;
  }

  onChange = (value: string) => {};
  onTouched = (value: string) => {};

  ngOnInit(): void {
    this.subscription = this.form.valueChanges.subscribe((value) => {
      this.onChange(value);
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  writeValue(obj: any): void {
    this.form.setValue(obj);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {}
}
